import React, { Fragment } from "react";
import { Link } from "react-router-dom";
// import { verifyEmailCall } from "../services";

export default function Verify({ match }) {
  //   const token = match.params.token;
  //   console.log("This is the match",match)
  //   console.log("Token", token);
  //   const [isVerified, setIsVerified] = useState(false);
  //   const [isLoading, setIsLoading] = useState(true);

  //   const verifyToken = async (token) => {
  //     try {
  //       await verifyEmailCall(token);
  //       setIsVerified(true);
  //     } catch (err) {
  //       setIsVerified(false);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   useEffect(() => {
  //     verifyToken(token);
  //   }, [token]);


  return (
    // <Fragment>
    //   {isLoading ? (
    //     <span>Loading....</span>
    //   ) : isVerified ? (
    //     <div className="verify">
    //       <img
    //         src="https://res.cloudinary.com/drqltx8ye/image/upload/v1607613652/38219-verification-badge_fotqsb.gif"
    //         alt="verify"
    //       />
    //       <h1> Your Account has been verified successfully! </h1>
    //       <Link to="/login-individual"> Sign in to your account </Link>
    //     </div>
    //   ) : (
    //     <div>It failed....</div>
    //   )}
    // </Fragment>
    <Fragment>
      <div className="verify">
        <img
          src="https://res.cloudinary.com/drqltx8ye/image/upload/v1607613652/38219-verification-badge_fotqsb.gif"
          alt="verify"
        />
        <h1> Your Account has been verified successfully! </h1>
        <Link to="#"> Please close the tab to continue your login</Link>
      </div>
    </Fragment>
  );
}
